<template>
    <ShowMypage/>
</template>

<script>
import ShowMypage from '@/components/ShowMypage.vue'
  export default {
      components:{
          ShowMypage
      },
    
   
  }
</script>